/* WebComponentVideo template */
import { Host, h, FunctionalComponent } from '@stencil/core'; // eslint-disable-line @typescript-eslint/no-unused-vars
import { VideoComponent } from './cwc-video';

/**
 * Definition of  parameters that the template needs to work.
 */
interface VideoTemplateProps {
  /**
   * The class instance that provides controller functionality for the template
   */
  controller: VideoComponent;
  // Specify parameters that are required to be passed down to the template here.
}

const VideoTemplate: FunctionalComponent<VideoTemplateProps> = ({ controller }) => (
  <Host class={controller.isMobile ? 'mobile' : 'desktop'}>
    <cwc-video-head>
      <video
        poster={controller.posterUrl}
        autoplay={controller.autoplay}
        loop={controller.loop}
        muted={controller.muted}
        playsinline={controller.playsInline}
      >
        <source src={controller.videoUrl} type={`video/${controller.getVideoType()}`} />
      </video>
      <cwc-video-headline style={!controller.headlineElement ? { display: 'none' } : {}}>
        <slot name="headline" />
      </cwc-video-headline>
    </cwc-video-head>
    <cwc-video-description style={!controller.descriptionElement ? { display: 'none' } : {}}>
      <slot name="description" />
    </cwc-video-description>
  </Host>
);

export default VideoTemplate;
